import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api/api';
import {
  ListPageShell, ListPageHeader, ListSearchBar, ListFilterSelect,
} from '../components/ui/ListPageChrome';

const STATUS_COLORS = {
  Draft:     'bg-[#F0F4F3] text-[#6B7F7F]',
  Open:      'bg-[#E8F4FE] text-[#2184F2]',
  Closed:    'bg-[#EDF2F7] text-[#4A6FA5]',
  Cancelled: 'bg-[#FDF0EE] text-[#C4574B]',
};

export default function InventoryTransferRequests() {
  const navigate = useNavigate();
  const [rows, setRows]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch]   = useState('');
  const [statusFilter, setStatusFilter] = useState('');

  useEffect(() => {
    api.get('/inventory-transfer-requests')
      .then((d) => { setRows(d || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const filtered = rows.filter((r) => {
    if (statusFilter && r.status !== statusFilter) return false;
    if (search) {
      const q = search.toLowerCase();
      return (
        (r.request_number || '').toLowerCase().includes(q)
        || (r.from_wh_code || '').toLowerCase().includes(q)
        || (r.to_wh_code || '').toLowerCase().includes(q)
        || (r.bp_name || '').toLowerCase().includes(q)
      );
    }
    return true;
  });

  return (
    <ListPageShell>
      <ListPageHeader
        title="Inventory Transfer Requests"
        action={
          <button type="button" onClick={() => navigate('/inventory/transfer-request/new')} className="btn-primary">
            + Add New
          </button>
        }
      />

      <div className="flex flex-wrap gap-3 items-center">
        <ListSearchBar
          value={search}
          onChange={setSearch}
          placeholder="Search request no., warehouse, partner…"
        />
        <ListFilterSelect value={statusFilter} onChange={setStatusFilter}>
          <option value="">All Statuses</option>
          {['Draft', 'Open', 'Closed', 'Cancelled'].map((s) => <option key={s} value={s}>{s}</option>)}
        </ListFilterSelect>
      </div>

      <div className="data-table-wrap">
        {loading ? (
          <div className="py-12 text-center text-sm text-sap-textLight">Loading…</div>
        ) : (
          <table className="w-full text-sm">
            <thead>
              <tr className="table-head">
                <th className="text-center px-4 py-3 font-semibold text-2xs uppercase tracking-wider w-10">#</th>
                <th className="text-left px-4 py-3 font-semibold text-2xs uppercase tracking-wider">Request No.</th>
                <th className="text-left px-4 py-3 font-semibold text-2xs uppercase tracking-wider">Posting Date</th>
                <th className="text-left px-4 py-3 font-semibold text-2xs uppercase tracking-wider">Due Date</th>
                <th className="text-left px-4 py-3 font-semibold text-2xs uppercase tracking-wider">From Wh</th>
                <th className="text-left px-4 py-3 font-semibold text-2xs uppercase tracking-wider">To Wh</th>
                <th className="text-center px-4 py-3 font-semibold text-2xs uppercase tracking-wider">Lines</th>
                <th className="text-left px-4 py-3 font-semibold text-2xs uppercase tracking-wider">Status</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr><td colSpan={8} className="px-4 py-8 text-center text-sap-textLight">No requests found.</td></tr>
              ) : filtered.map((r, i) => (
                <tr
                  key={r.request_id}
                  onClick={() => navigate(`/inventory/transfer-request/${r.request_id}`)}
                  className="table-row even:bg-gray-50/50"
                >
                  <td className="text-center px-4 py-3 text-sap-textLight">{i + 1}</td>
                  <td className="px-4 py-3 font-semibold text-sap-blue">{r.request_number}</td>
                  <td className="px-4 py-3 text-sap-textLight">{r.posting_date ? r.posting_date.slice(0, 10) : '—'}</td>
                  <td className="px-4 py-3 text-sap-textLight">{r.due_date ? r.due_date.slice(0, 10) : '—'}</td>
                  <td className="px-4 py-3 font-mono">{r.from_wh_code || '—'}</td>
                  <td className="px-4 py-3 font-mono">{r.to_wh_code || '—'}</td>
                  <td className="text-center px-4 py-3 text-sap-textLight">{r.line_count || 0}</td>
                  <td className="px-4 py-3">
                    {r.status === 'Open' ? (
                      <span className="badge-active">{r.status}</span>
                    ) : (
                      <span className={`px-2.5 py-0.5 rounded-lg text-xs font-semibold ${STATUS_COLORS[r.status] || ''}`}>{r.status}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {!loading && (
        <p className="text-xs text-sap-textLight">{filtered.length} request{filtered.length !== 1 ? 's' : ''}</p>
      )}
    </ListPageShell>
  );
}
